import React from 'react';
import CtResultTable from './table/CtResultTable';

const ResultContent: React.FC = () => {
  return <CtResultTable />;
};

export default ResultContent;
